import request from '@/router/axios'
import env from '@/config/env'

/**
 * 获取列表
 */
export const getFerryDriverList = (data) => {
  return request({
    url: `${env.ferryUrl}/ferry-driver/attendance/list`,
    method: 'post',
    data
  })
}

/**
 * 查询总计时长
 */
export const getFerryDriverTotalTime = (data) => {
  return request({
    url: `${env.ferryUrl}/ferryDriver/totalTime`,
    method: 'post',
    data
  })
}

/**
 * 查询司机轨迹
 */
export const getFerryDriverTrack = (traceId) => {
  return request({
    url: `${env.ferryUrl}/ferry-driver/attendance/trace?traceId=${traceId}`,
    method: 'get'
  })
}

/*
 * 获取摆渡司机列表
 */
export const getFerryDriverAllList = () => {
  return request({
    url: `${env.ferryUrl}/ferry-driver/attendance/drivers`,
    method: 'get'
  })
}

/**
 * 获取摆渡司机详情
 */
export const getFerryDriverDetail = (id) => {
  // 逻辑接口，需要的话可以替换为真实接口
  return request({
    url: `${env.ferryUrl}/ferryDriver/${id}`,
    method: 'get'
  })
}
